/**
 * 관리자 로그인 (/adm/login) — 관리자 틀 없는 단독 화면(AdminLTE 로그인 카드)
 * ($j.Pages.Admin.AdminLogin / body data-page-name="AdminLogin")
 *
 * 예전 인라인 스크립트에서 쓰이던 것만 옮겼다 — 아이디 대시 자동입력·엔터 로그인·빈 칸 경고.
 * (아무 데서도 부르지 않던 test·google_apk·showLoginbox 는 옮기지 않았다)
 */
export default class AdminLogin {
    initialize() {
        // 폼 전송은 formCheck 가 false 를 돌려줄 때만 막는다 — 예전 onSubmit="return formCheck();" 와 같은 판정
        $('form[name=memlogin]').on('submit', (e) => { if (formCheck() === false) e.preventDefault(); });
        $('#btnAdminLogin').on('click', formCheck);
        $('#mem_id').on('keyup', function (e) { chthis(this, e); });
        $('#mem_pwd').on('keyup', onkeyup_colfield_check);
        $('a[data-al-noop]').on('click', (e) => e.preventDefault());
        startBackground(document.getElementById('alBg'));
    }
}

// picsum.photos 사진 번호 — 주제를 골라 받을 수 없어 자연 풍경만 골라 적었다
const BG_PHOTO_IDS = [10, 11, 13, 14, 15, 16, 17, 18, 28, 29, 37, 38, 46, 54];
const BG_INTERVAL_MS = 15000;

/** 배경 사진을 무작위 순서로 돌린다. 다 받은 뒤에 겹쳐 바꾸고, 못 받은 사진은 건너뛴다. 움직임 줄이기 설정이면 한 장만 */
function startBackground(box) {
    const ids = [...BG_PHOTO_IDS].sort(() => Math.random() - .5);
    let next = 0;
    let current = null;

    const show = () => {
        const img = new Image();
        img.alt = '';
        img.referrerPolicy = 'no-referrer';
        img.onload = () => {
            box.appendChild(img);
            img.getBoundingClientRect();   // 붙인 직후 상태를 확정해야 opacity 전환이 돈다
            img.classList.add('on');
            const old = current;
            current = img;
            if (old) setTimeout(() => old.remove(), 2000);
        };
        img.src = `https://picsum.photos/id/${ids[next++ % ids.length]}/1920/1080`;
    };

    show();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(show, BG_INTERVAL_MS);
}

function formCheck(){
    var form = document.memlogin;
    if(form.mem_id.value==""){
        alert("아이디를 입력해 주세요");
        form.mem_id.focus();
        return false;
    }else if(form.mem_pwd.value==""){
        alert("비밀번호 입력해 주세요");
        form.mem_pwd.focus();
        return false;
    }
    form.submit();
}

function onkeyup_colfield_check(e){
    var charCode = (typeof e.which === "number") ? e.which : e.keyCode;
    if(charCode==13) formCheck();
}

// 기사 로그인 유형 체크가 있을 때만 전화번호 대시를 넣던 것 — 이 화면엔 그 체크가 없다(#logintypedirver).
// 예전엔 그래서 키를 칠 때마다 null.checked 로 오류가 났다. 체크가 없으면 아무것도 안 한다.
function chthis(tar,evt){
    var obj = document.getElementById("logintypedirver");
    if(obj && obj.checked==true){
        check_nns(tar,evt);
    }
}

function check_nns(obj,e){
    if( obj.value == "전화번호입력") obj.value="";
    $j.Common.Util.phoneDashOnKey(obj, e);
}
